// extracted by mini-css-extract-plugin
export default {"pageContainer":"login_pageContainer__Sr2Wi","loginContainer":"login_loginContainer__D+mZM","forgotPasswordLink":"login_forgotPasswordLink__5pe2b"};